import { setDatadogABTestValues } from 'dibs-ab-tests/exports/clientAbTestV2.ts';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes.ts';
import { datadog, homeTypes, initSharedDatadogRum } from 'dibs-datadog/exports/datadog.ts';
import serverVars from 'server-vars';

type HomePageSubType = (typeof homeTypes)[keyof typeof homeTypes];

export const initHomepageDatadog = (pageSubType: HomePageSubType): void => {
    datadog.load().then(dd => {
        initSharedDatadogRum(dd, {
            page: PAGE_TYPE.HOME,
            pageSubType,
            device: serverVars.get('settings.isMobile') ? 'mobile' : 'resp',
        });
        setDatadogABTestValues();
    });
};
